import { render, staticRenderFns } from "./dealerRegistrationAndServiceTable.vue?vue&type=template&id=7a60e88d&scoped=true"
import script from "./dealerRegistrationAndServiceTable.vue?vue&type=script&lang=js"
export * from "./dealerRegistrationAndServiceTable.vue?vue&type=script&lang=js"
import style0 from "./dealerRegistrationAndServiceTable.vue?vue&type=style&index=0&id=7a60e88d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a60e88d",
  null
  
)

export default component.exports